module.exports = __webpack_public_path__ + "img/bronce.12dcbcaa.png";